// extracted by mini-css-extract-plugin
export var colorSquare = "_ri-0";
export var danger = "_ri-5";
export var lightPink = "_ri-8";
export var neutralBlue = "_ri-7";
export var neutralYellow = "_ri-6";
export var normal = "_ri-1";
export var primary = "_ri-2";
export var primaryLight = "_ri-3";
export var solidBlack = "_ri-g";
export var solidGreen = "_ri-b";
export var solidLightBlue = "_ri-d";
export var solidNavy = "_ri-c";
export var solidOrange = "_ri-f";
export var solidPink = "_ri-e";
export var solidRed = "_ri-9";
export var solidYellow = "_ri-a";
export var success = "_ri-4";